import React, { Fragment } from 'react';

import t from '../../../labels/labelling-utils';
import { Role as PlayerRole, Role, roleList as playerRoleList } from '../../../typings/player';
import { isEmptyArray } from '../../../utils/array';
import { getErrorComponent } from '../../../utils/helper-components';
import { makeClassNames } from '../../../utils/styles';
import TableHead from '../../atoms/table-head/table-head';
import TeamRow, { ITeamRow } from '../../molecules/team-row/team-row';
import ErrorBoundary from '../../templates/error-boundary/error-boundary';

import './team-players-table.scss';

export interface ITeamPlayer extends ITeamRow {
  role: PlayerRole;
  // UNUSED  fields (from BE query)
  id?: string;
  name?: string;
  surname?: string;
}

export interface ITeamPlayersTable {
  playerList: ITeamPlayer[];
}

const classNames = () => {
  return makeClassNames({
    table: 'team-players-table',
    body: 'team-players-table__body',
    header: 'team-players-table__header',
    headerTd: 'team-players-table__header-td',
  });
};

const TeamPlayersTable = ({ /* istanbul ignore next: default value */ playerList = [] }: ITeamPlayersTable) => {
  const cn = classNames();

  const columnsLabels = [
    t('team.players.th.number'),
    t('team.players.th.country'),
    t('team.players.th.name'),
    t('team.players.th.age'),
    t('team.players.th.height'),
    t('team.players.th.weight'),
  ];

  const labelsRole: {
    [key in Role]: string;
  } = {
    Goalkeeper: t('team.players.label.keeper'),
    Defender: t('team.players.label.fullback'),
    Midfielder: t('team.players.label.midfielder'),
    Forward: t('team.players.label.striker'),
    Manager: t('team.players.label.coach'),
  };

  return (
    <ErrorBoundary hasError={isEmptyArray(playerList)} errorComponent={getErrorComponent()}>
      <table className={cn.table}>
        <TableHead columns={columnsLabels} />
        <tbody className={cn.body}>
          {/* Iterate ROLES */}
          {playerRoleList.map((role: Role) => {
            // Take only PLAYERS with given ROLE
            const players: ITeamPlayer[] = playerList.filter((player) => player.role === role);
            // .sort((prev, next) => prev.jerseyNum - next.jerseyNum);

            return (
              <Fragment key={role}>
                {players.length ? (
                  <tr className={cn.header}>
                    <td className={cn.headerTd} colSpan={columnsLabels.length}>
                      {labelsRole[role]}
                      {'\u00a0'}
                    </td>
                  </tr>
                ) : null}
                {players.length
                  ? players.map((player: ITeamPlayer, index: number) => <TeamRow key={index} {...player} />)
                  : null}
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </ErrorBoundary>
  );
};

export default TeamPlayersTable;
